@if (settings$() | async; as settings) {
	<form [formGroup]="form" name="form" class="form">
		<stages-input (changedControlKey)="save(settings)" [form]="form" [input]="personalityInput"></stages-input>
	</form>
}
